export default __webpack_public_path__ + "static/old-new-game-success-icon-2addb2587639429c342b8b06b3e5f1a1.svg";